import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";

export default function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const pathToPageName = {
        "/": "Home",
        "/projects": "Projects",
        "/about": "About Us",
        "/gallery": "Gallery",
        "/payment-plans": "Payment Plans",
        "/contact": "Contact",
    };

    const page = pathToPageName[currentPath] || "";

    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 820);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 820);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (!isMobile) {
            setMenuOpen(false);
        }
    }, [isMobile]);

    const unselectedNavLink = {
        height: "100px",
        fontSize: "20px",
        paddingTop: "14px",
        borderBottom: "3px solid transparent",
        transition: "0.2s linear all",
    };

    const selectedNavLink = {
        ...unselectedNavLink,
        borderBottom: "3px solid #FECC7B",
        color: "#FECC7B",
    };

    const unselectedNavLinkMobile = {
        fontSize: "20px",
        borderBottom: "3px solid transparent",
        transition: "0.2s linear all",
        width: "fit-content",
        paddingTop: "25px",
        paddingBottom: "25px",
    };

    const selectedNavLinkMobile = {
        ...unselectedNavLinkMobile,
        borderBottom: "3px solid #FECC7B",
        color: "#FECC7B",
    };

    const navLinks = [
        { name: "Home", path: "/" },
        { name: "Projects", path: "/projects" },
        { name: "About Us", path: "/about" },
        { name: "Gallery", path: "/gallery" },
        { name: "Payment Plans", path: "/payment-plans" },
        { name: "Contact", path: "/contact" },
    ];

    const nav = (
        <div
            className="bg-primary-blue flex items-center w-screen"
            style={{
                position: "fixed",
                filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
                zIndex: "2",
            }}
        >
            <img
                src="/Logo.png"
                alt="sultana-homes-logo"
                style={{ height: "80px"}}
                onClick={() => navigate("/")}
                className="hover:cursor-pointer"
            />
            <div className="flex flex-nowrap lg:gap-x-16 md:gap-x-5 sm:gap-x-0 ml-28">
                {navLinks.map((navLink) => (
                    <div
                        key={navLink.name}
                        style={
                            page === navLink.name
                                ? selectedNavLink
                                : unselectedNavLink
                        }
                        className="font-montserrat font-medium hover:text-primary-gold flex items-center hover:cursor-pointer text-primary-darkgold"
                        onClick={() => navigate(navLink.path)}
                    >
                        {navLink.name}
                    </div>
                ))}
            </div>
        </div>
    );

    const mobileNav = (
        <div>
            <div
                className="bg-primary-blue flex items-center w-screen justify-between pr-7"
                style={{
                    position: "fixed",
                    filter: menuOpen
                        ? "none"
                        : "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
                    height: "100px",
                    zIndex: "2",
                }}
            >
                <img
                    src="/Logo.png"
                    alt="sultana-homes-logo"
                    className="hover:cursor-pointer"
                    onClick={() => navigate("/")}
                />
                <div
                    style={{ color: "white" }}
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="hover:cursor-pointer"
                >
                    {menuOpen ? (
                        <CloseOutlined className="text-2xl text-primary-gold" />
                    ) : (
                        <MenuOutlined className="text-2xl text-primary-gold" />
                    )}
                </div>
            </div>
            {menuOpen && (
                <div
                    style={{
                        marginTop: "100px",
                        position: "fixed",
                        width: "100%",
                        zIndex: "2",
                    }}
                    className="bg-primary-blue flex flex-col items-center"
                >
                    {navLinks.map((navLink) => (
                        <div
                            key={navLink.name}
                            style={
                                page === navLink.name
                                    ? selectedNavLinkMobile
                                    : unselectedNavLinkMobile
                            }
                            className="font-montserrat font-medium hover:text-primary-gold flex items-center hover:cursor-pointer text-primary-darkgold"
                            onClick={() => {
                                navigate(navLink.path);
                                setMenuOpen(false);
                            }}
                        >
                            {navLink.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    return isMobile ? mobileNav : nav;
}
